<template>
    <div class="container text-center my-4">
      <h2>Confirmar Edad y Términos</h2>
      <input v-model="age" type="number" class="form-control my-3" placeholder="Edad" />
      <div class="form-check my-2">
        <input v-model="acceptTerms" type="checkbox" class="form-check-input" id="terms" />
        <label class="form-check-label" for="terms">
          Para continuar, debes aceptar los términos y condiciones para esta experiencia
        </label>
      </div>
      <button class="btn btn-primary" @click="validateForm">Aceptar</button>
      <p v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</p>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        age: '',
        acceptTerms: false,
        errorMessage: '',
      };
    },
    methods: {
      validateForm() {
        if (!this.age || this.age < 18) {
          this.errorMessage = 'Debes ingresar una edad válida (mayor de 18).';
        } else if (!this.acceptTerms) {
          this.errorMessage = 'Debes aceptar los términos y condiciones.';
        } else {
          this.$router.push('/welcome-new-experience');
        }
      },
    },
  };
  </script>
  
  <style scoped>
  h2 {
    color: #007bff;
  }
  
  .text-danger {
    font-size: 1rem;
  }
  </style>
  